import { keymap } from "prosemirror-keymap";
import { Extension } from "../../core/extension";
/**
 * Override Tab/Shift-Tab keys behaviour to block focus from leaving the editor.
 * This plugin should be added last in the array of plugins given to the editor.
 */
export class TabsExtension extends Extension {
    addPlugins(schema, plugins) {
        return plugins.concat([
            keymap({
                Tab: () => true,
                "Shift-Tab": () => true,
            }),
        ]);
    }
}
